export default "__VITE_ASSET__rhiLS28m__"